import { from, Observable } from 'rxjs';
import { isSupportedLanguage, Language } from '@core/enums/language';
import { CriticalError } from '@core/services/critical-error';
import { TranslateLoader } from '@ngx-translate/core';

export type Translation = { [key: string]: string | string[] | Translation };

type TranslationModule = {
  default: Translation;
};

const FALLBACK_TRANSLATION: TranslationModule = {
  default: {}
};

export class ModuleTranslateLoader implements TranslateLoader {
  constructor(private criticalErrorService: CriticalError) {}

  // eslint-disable-next-line rxjs/finnish
  getTranslation(lang: string): Observable<Translation> {
    return from(
      this.loadTranslation(lang).catch(error => {
        this.criticalErrorService.panic(error);
        return FALLBACK_TRANSLATION;
      })
    );
  }

  private async loadTranslation(lang: string): Promise<Translation> {
    if (!isSupportedLanguage(lang)) {
      throw new Error(`Language ${lang} is not supported`);
    }

    let result: { default: Translation };
    switch (lang) {
      case Language.English:
        result = await import('@i18n/en.json');
        break;
      case Language.Bokmal:
        result = await import('@i18n/nb-NO.json');
        break;
      case Language.Nynorsk:
        result = await import('@i18n/nn-NO.json');
        break;
      default:
        throw new Error(`Language ${String(lang)} is not supported`);
    }
    return result.default;
  }
}
